import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { logEventGA4 } from '../../google';
import { migrateReduxSessionStorageFilterValue, sessionStorageMF } from '../../utils';
import { setFilterValue } from '../filterValue';

const initialState = {
  display: 'Experience',
  name: 'doctorYearsExperience',
  type: 'singleSelect',
  selected: { value: 0, display: 'Any' },
  options: [
    { value: 0, display: 'Any' },
    { value: 5, display: '5 or more years' },
    { value: 10, display: '10 or more years' },
    { value: 15, display: '15 or more years' },
    { value: 25, display: '25 or more years' },
  ],
};

const storeName = 'doctorYearsExp';
export const useDoctorYearsExpFilter = create(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        set,
        reset: () => set({ ...initialState }, false, { type: 'reset' }),
        getInitialState: () => ({ ...initialState }),
        setFilterValue: (v) => updateDoctorExpFilterOption(v),
      }),
      {
        name: `${process.env.NX_APP}-${storeName}`,
        version: 0,
        storage: createJSONStorage(() => sessionStorageMF),
        onRehydrateStorage: () => (state) => {
          migrateReduxSessionStorageFilterValue({ state, key: 'doctorYearsExperience' });
        },
      },
    ),
    {
      name: `${process.env.NX_APP}`,
      store: storeName,
    },
  ),
);

export const updateDoctorExpFilterOption = (option) => {
  if (option && process.env.NX_APP === 'MediFind-Pro') {
    const { value } = option;
    logEventGA4('filter', { type: 'doctor_years_experience', action: 'select', item_id: value }, 'f5116aeb-521d-4872-973f-0a421a2af689');
  }
  setFilterValue(useDoctorYearsExpFilter, option);
};

export const clearDoctorExpFilterOption = () => useDoctorYearsExpFilter.setState((set) => ({ ...initialState }));
